import {
  LayoutContextProvider,
  LayoutName,
} from "components/context/LayoutContext";
import Icon from "components/ui/Icon";
import React from "react";
import { UIMatch } from "react-router-dom";
import { useDeleteUsersSignOutMutation } from "store/api/apiSlice";
import { RouteHandle } from "types/router";
import { getPartnerConfig } from "utils/partner";
import { ButtonLevel, ButtonSize } from "../Button";
import { NAVIGATION } from "./constants";
import * as Styled from "./styled";
import { pathMatchesRoute } from "./utils";

interface Props {
  matches: UIMatch<unknown, RouteHandle>[];
}

const Navigation: React.FC<Props> = ({ matches }) => {
  const [logOut] = useDeleteUsersSignOutMutation();
  const showMobileMenuButton = false;
  const partner = getPartnerConfig();

  const onClickLogOut = async () => {
    await logOut();

    window.location.href = "/";
  };

  return (
    <LayoutContextProvider name={LayoutName.fullWidth}>
      <Styled.Wrapper>
        <Styled.NavInner>
          <Styled.LogoWrapper>
            <img src={`/partner/${partner.slug}/logo.svg`} alt={partner.name} />
          </Styled.LogoWrapper>

          <Styled.NavItems $showMobileMenuButton={showMobileMenuButton}>
            {NAVIGATION.map((item) => {
              const isActive = matches.some(pathMatchesRoute(item));

              return (
                <Styled.NavItem key={item.title}>
                  <Styled.NavLink
                    to={item.path ? `/${item.path}` : "#"}
                    data-turbo="false"
                    $isActive={isActive}
                  >
                    <Icon
                      name={isActive ? item.iconActive : item.icon}
                      color="primary"
                    />
                    <Styled.Label $isActive={isActive}>
                      {item.title}
                    </Styled.Label>
                  </Styled.NavLink>
                </Styled.NavItem>
              );
            })}

            <Styled.NavItem $isDesktopOnly>
              <Styled.NavButton
                size={ButtonSize.sm}
                level={ButtonLevel.ghost}
                onClick={onClickLogOut}
              >
                Log Out
              </Styled.NavButton>
            </Styled.NavItem>
          </Styled.NavItems>
        </Styled.NavInner>
      </Styled.Wrapper>
    </LayoutContextProvider>
  );
};

export default Navigation;
